import { render, staticRenderFns } from "./detailcard.vue?vue&type=template&id=ffafcb98&scoped=true"
import script from "./detailcard.vue?vue&type=script&lang=js"
export * from "./detailcard.vue?vue&type=script&lang=js"
import style0 from "./detailcard.vue?vue&type=style&index=0&id=ffafcb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffafcb98",
  null
  
)

export default component.exports